import { responsiveMediaFragment } from '~/gql/mediaFragments.gql'
import {
  localeFragment,
} from './fragments.gql'
import {
  genericStructuredTextFragment
} from './structuredText.gql'

export default `query 
  StravaQuery($locale: SiteLocale) {
    strava(${localeFragment}) {
      competition {
        id
        competitionId
        slug
      }
      ${responsiveMediaFragment('headlineImage')}
      ${responsiveMediaFragment('badgeImage')}
      formTitleSection {
        ${genericStructuredTextFragment}
      }
      formButtonText
      formVerificationRequiredText {
        ${genericStructuredTextFragment}
      }
      formTerms {
        ${genericStructuredTextFragment}
      }
      mailingAgreementText
      termsAgreementText
      stickyButtonText
    }
  }`
